import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.TwitterProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/twitter_profile']
  id: 'twitter-profile'
